import React, { Component } from "react";

// Tooltip (i) แบบเดียวกับหน้าสินทรัพย์ - hover หรือคลิกไอคอนแล้วเปิดการ์ดลอยเหนือไอคอน
// (position: fixed จับพิกัดจาก getBoundingClientRect ตอนเปิด เพราะไอคอนอยู่ใน modal ที่ scroll ได้)
export default class InfoTooltip extends Component {
  state = { open: false, rect: null };

  openTooltip = (e) => this.setState({ open: true, rect: e.currentTarget.getBoundingClientRect() });

  closeTooltip = () => this.setState({ open: false, rect: null });

  toggleTooltip = (e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    this.setState((state) => ({ open: !state.open, rect: state.open ? null : rect }));
  };

  render() {
    const { open, rect } = this.state;

    return (
      <span
        style={{ position: "relative", display: "inline-block", marginLeft: "4px", cursor: "pointer" }}
        onMouseEnter={this.openTooltip}
        onMouseLeave={this.closeTooltip}
        onClick={this.toggleTooltip}
      >
        <span className="icon text-secondary" style={{ fontSize: "12px" }}>{"\uf05a"}</span>
        {open && (
          <div
            style={{
              position: "fixed",
              bottom: rect ? `${window.innerHeight - rect.top + 6}px` : "50%",
              left: rect ? `${rect.left + rect.width / 2}px` : "50%",
              transform: "translateX(-50%)",
              background: "#fff",
              border: "1px solid #dee2e6",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
              padding: "10px 14px",
              zIndex: 9999,
              width: this.props.width || "max-content",
              maxWidth: "min(300px, calc(100vw - 24px))",
              textAlign: "left",
              fontSize: "12px",
              fontWeight: "normal",
              color: "#333",
              whiteSpace: "normal",
            }}
          >
            {this.props.title && <div className="fw-bold text-dark mb-2">{this.props.title}</div>}
            <div className="text-secondary">{this.props.children}</div>
          </div>
        )}
      </span>
    );
  }
}
